import * as model from '././model'
let moment = require('moment');

//import * as firebase from 'firebase/app';

export interface IProfileProvider {
    authenticate(email: string, password: string): Promise<string>;
    setToken(token: string): Promise<model.Profile>;
    authenticateWithGoogle(googleToken: string): Promise<string>;
    getProfile(): model.Profile;
}
export class FireStoreUtil {
    static getServerDate() {
        return new Date();
    };
    static isFirestoreDate(obj: any, firebase: any): boolean {
        if (!obj) {
            return false;
        }
        if (obj instanceof firebase.firestore.Timestamp) {
            return true;
        }
        if (obj.nanoseconds != null) {
            return true;
        }

        if (obj._nanoseconds != null) {
            return true;
        }
        return false;

    }
    static convertFromFireStoreDate = function (date: any, firebase: any): Date {
        if (!date) {
            //@ts-ignore
            return null;
        }


        if (date instanceof firebase.firestore.Timestamp) {
            let d = date;
            return d.toDate();
        }
        if (date.nanoseconds != null) {
            return new firebase.firestore.Timestamp(date.seconds as number, date.nanoseconds as number).toDate();
        }

        if (date._nanoseconds != null) {
            return new firebase.firestore.Timestamp(date._seconds as number, date._nanoseconds as number).toDate();
        }
        if (date instanceof Date)
            return date;
        if (typeof date == 'string') {
            return new Date(date as string);
        }
        throw "Convert From Unknown Date " + date;
    }
    static toPureJavascriptWithFireStoreDate(obj: any, firebase: any): any {
        if (obj === null || typeof obj !== "object" || "isActiveClone" in obj)
            return obj;

        var temp = {};
        if (obj instanceof Date) temp = FireStoreUtil.toPureJavascriptWithFireStoreDate(firebase.firestore.Timestamp.fromDate(obj), firebase)
        else
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    obj["isActiveClone"] = null;
                    var r = FireStoreUtil.toPureJavascriptWithFireStoreDate(obj[key], firebase);
                    if (typeof r != "undefined") temp[key] = r;
                    delete obj["isActiveClone"];
                }
            }

        return temp;
    }
}
export class UpdateCallback<T> {
    public key: string;
    public dispatch: any;
    public callback: (todos: Array<T>) => void;
    constructor(key: string, dispatch: any, callback: (todos: Array<T>) => void) {
        this.key = key;
        this.dispatch = dispatch;
        if (dispatch) {
            this.callback = (todos: Array<T>) => {
                dispatch(callback(todos));
            };
        } else {
            this.callback = callback;
        }
    }
}

export class Context {
    dispatch: any;
    private _db: any;
    ProfileProvider: IProfileProvider;
    PodCast: PodCastStore;
    Track: TrackStore;
    BackgroundJob: BackgroundJobStore;
    CustomerBalance: CustomerBalanceStore;
    Transaction: TransactionStore;
    CustomerSettings: CustomerSettingsStore;
    firebase: any;


    generateNewId(): any {
        let generatePushID = (function () {
            // Modeled after base64 web-safe chars, but ordered by ASCII.
            var PUSH_CHARS =
                "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";

            // Timestamp of last push, used to prevent local collisions if you push twice in one ms.
            var lastPushTime = 0;

            // We generate 72-bits of randomness which get turned into 12 characters and appended to the
            // timestamp to prevent collisions with other clients.  We store the last characters we
            // generated because in the event of a collision, we'll use those same characters except
            // "incremented" by one.
            var lastRandChars = [];

            return function () {
                var now = new Date().getTime();
                var duplicateTime = now === lastPushTime;
                lastPushTime = now;

                var timeStampChars = new Array(8);
                for (var i = 7; i >= 0; i--) {
                    timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
                    // NOTE: Can't use << here because javascript will convert to int and lose the upper bits.
                    now = Math.floor(now / 64);
                }
                if (now !== 0)
                    throw new Error("We should have converted the entire timestamp.");

                var id = timeStampChars.join("");

                if (!duplicateTime) {
                    for (i = 0; i < 12; i++) {
                        //@ts-ignore
                        lastRandChars[i] = Math.floor(Math.random() * 64);
                    }
                } else {
                    // If the timestamp hasn't changed since last push, use the same random number, except incremented by 1.
                    for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                        //@ts-ignore
                        lastRandChars[i] = 0;
                    }
                    lastRandChars[i]++;
                }
                for (i = 0; i < 12; i++) {
                    id += PUSH_CHARS.charAt(lastRandChars[i]);
                }
                if (id.length != 20) throw new Error("Length should be 20.");

                return id;
            };
        })();
        return generatePushID().replace("-", "");
    }
    getDb(): any {
        if (!this._db) {
            this._db = this.firebase.firestore();
        }
        return this._db;
    }
    getId(): any {
        return this.ProfileProvider.getProfile().uid;
    }
    getProfile(): model.Profile {
        return this.ProfileProvider.getProfile();
    }
    constructor(profileProvider: IProfileProvider, firebase: any) {
        this.firebase = firebase;
        this.ProfileProvider = profileProvider;
        this.PodCast = new PodCastStore(this);
        this.Track = new TrackStore(this);
        this.BackgroundJob = new BackgroundJobStore(this);
        this.CustomerBalance = new CustomerBalanceStore(this);
        this.Transaction = new TransactionStore(this);
        this.CustomerSettings = new CustomerSettingsStore(this);
    }
}
export class QueryListener<T> {
    private updatesCallback?: (notes: Array<T>) => void;
    private resultsCallback: (notes: Array<T>) => void;
    private snapshots: Map<string, any> = new Map<string, any>();
    private datasets: Map<string, boolean> = new Map<string, boolean>();
    private receivedFirst: boolean = false;
    private cache: Map<string, Array<T>> = new Map<string, Array<T>>();
    private sort: (n1: T, n2: T) => number;
    getSnapShot(query: any, cb: any): any {

        return query.onSnapshot(
            { includeMetadataChanges: false },
            cb
            , function (error: any) {


                console.error('snapshot error', error)
            })
    }
    private receiveData(queryName: any, items: Array<T>) {
        this.cache.set(queryName, items);
        console.log(">> Recevied " + queryName + " " + items.length);
        var resultCache = new Map<any, T>();

        this.cache.forEach((arr, key) => {
            if (key != queryName) {
                for (var k in arr) {
                    resultCache.set(arr[k]["id"], arr[k]);
                }
            }
        });
        for (var i in items) {
            resultCache.set(items[i]["id"], items[i]);
        }

        this.datasets.set(queryName, true);
        let results = new Array<T>();
        resultCache.forEach((value, key) => {
            results.push(value);
        });
        results = results.sort(this.sort);
        console.log(">> " + results.length);
        if (!this.receivedFirst) {
            let done: boolean = true;
            this.datasets.forEach((value, key) => {
                if (!value) {
                    done = false;
                }
            });

            this.receivedFirst = done;
            if (done) {
                console.log(">> done " + results.length);
                this.resultsCallback(results);
                if (!this.updatesCallback) {
                    this.stopListening();
                }
            } else {
                console.log(">> notdone " + results.length);
            }
        } else {
            console.log(">> update " + queryName + " " + results.length);

            if (this.updatesCallback)
                this.updatesCallback(results);
        }
    }
    public stopListening(): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            try {
                this.snapshots.forEach(async (value, key) => {
                    await value();
                });

                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }
    public constructor(
        ctx: Context,
        queries: Map<string, any>,
        sort: (n1: T, n2: T) => number,
        deserializer: (item: any, id?: any) => T,
        resultsCallback: (notes: Array<T>) => void,
        errorCallback: (e: any) => void,
        updateCallback?: (notes: Array<T>) => void
    ) {
        this.updatesCallback = updateCallback;
        this.resultsCallback = resultsCallback;
        var me = this;
        this.updatesCallback;
        this.sort = sort;

        queries.forEach((value, key) => {
            this.datasets.set(key, false);
            console.log("query " + key);
            me.snapshots.set(
                key,
                this.getSnapShot(value, function (querySnapshot: any) {
                    console.log('Got Results for ' + key)
                    var docs = new Array<T>();


                    querySnapshot.forEach(function (doc: any) {
                        var d = doc.data();
                        d.id = doc.id;
                        docs.push(deserializer(d));
                    });
                    me.receiveData(key, docs);
                })
            );
        });
    }
}
export class QueryListenerManager<T> {
    listeners: Map<any, QueryListener<T>> = new Map<any, QueryListener<T>>();
    async execute(
        ctx: Context,
        callbackqueries: Map<string, any>,
        sort: (n1: T, n2: T) => number,
        deserializer: (id: any, item: any) => T,
        resultsCallback: (notes: Array<T>) => void,
        errorCallback: (e: any) => void,
        updateCallback?: UpdateCallback<T>
    ) {
        try {
            var listenKey = "main";
            if (updateCallback) {
                listenKey = updateCallback.key;
                var l = await this.listeners.get(updateCallback.key);
                if (l) {
                    console.log("stop listening to " + updateCallback.key);
                    await l.stopListening();
                }
            }

            this.listeners.set(
                listenKey,
                new QueryListener<T>(
                    ctx,
                    callbackqueries,
                    sort,
                    deserializer,
                    resultsCallback,
                    errorCallback,
                    updateCallback ? updateCallback.callback : undefined
                )
            );
        }
        catch (e) {
            errorCallback(e)
        }
    }
}
abstract class BaseFireStore<T extends model.BaseItem<T>> {
    protected ctx: Context;
    protected _queryManager: QueryListenerManager<T> = new QueryListenerManager<
        T
    >();
    protected getDb(): any {
        //doing this because if you try to get firestore before it inits you get an error
        return this.ctx.getDb();
    }
    abstract databaseName(): string;
    abstract getNewObject(): T
    populateFromData(
        d: any,
        id?: any
    ): T {
        var retval = this.getNewObject();

        if (!d.id && !id) {
            throw `could not populateBaseFromData because id not found`;
        }
        let raw = d;
        if (id) retval.id = id;
        else retval.id = d.id;

        for (var i in raw) {
            if (FireStoreUtil.isFirestoreDate(raw[i], this.ctx.firebase)) {
                retval[i] = FireStoreUtil.convertFromFireStoreDate(raw[i], this.ctx.firebase);
            }
            else retval[i] = raw[i];
        }
        return retval;
    };
    protected getSort(): (a: T, b: T) => number {
        let f = this['overrideSort'];
        if (!f) {
            return (a: T, b: T) => {
                return a.created > b.created ? 1 : -1
            }
        }
        else return f;
    }
    protected isNew(obj: model.BaseItem<T>): boolean {
        return !obj.id || obj.id == -1 || obj.is_new === true;
    }
    protected populateToData(data: model.BaseItem<T>): any {
        var now = FireStoreUtil.getServerDate();
        if (!data.id || data.id == -1 || data.is_new) {
            data.owner_uid = this.ctx.getId();
            data.created = now;
            data.archived = null;
        }
        data.modified_uid = this.ctx.getId();
        data.modified = now

        var retval = FireStoreUtil.toPureJavascriptWithFireStoreDate(data, this.ctx.firebase);
        delete retval["id"];
        return retval;
    }

    list(
        updateCallback?: UpdateCallback<T>, where?: Array<Array<string>>
    ): Promise<Array<T>> {
        if (!updateCallback)
            return this.listCustom(where);
        return new Promise<Array<T>>((resolve, reject) => {
            var map = new Map<string, any>();
            let col = this.getDb()
                .collection(this.databaseName());



            col = col.where("owner_uid", "==", this.ctx.getId())

            col = col.where("archived", '==', null)
            if (where) {
                where.forEach(w => {
                    console.log('where = ', w[0], w[1], w[2])
                    col = col.where(w[0], w[1], w[2]);
                });
            }

            map.set(
                this.databaseName(), // Just to make it unique for the collection
                col
            );

            this._queryManager.execute(
                this.ctx,
                map,
                this.getSort(),
                (id: any, d: any): T => {
                    //doing this to bind it to the Store
                    return this.populateFromData(id, d)
                },
                resolve,
                reject,
                updateCallback
            );
        });
    }
    protected listCustom(
        where?: Array<Array<string>>
    ): Promise<Array<T>> {
        let me = this;
        return new Promise<Array<T>>(async (resolve, reject) => {

            let col = this.getDb()
                .collection(this.databaseName());

            if (where) {
                where.forEach(w => {
                    //console.log('where = ', w[0], w[1], w[2])
                    col = col.where(w[0], w[1], w[2]);
                });
            }

            col = col.where("owner_uid", "==", this.ctx.getId())

           col = col.where("archived", "==", null)

            let snapshot = await col.get();
            var docs = new Array<T>();


            snapshot.forEach(function (doc: any) {
                var d = doc.data();
                d.id = doc.id;

                docs.push(me.populateFromData(d, doc.id))
            });
            resolve(docs);

        });
    }
    save(obj: T): Promise<T> {
        return new Promise<T>(async (resolve, reject) => {
            try {

                var update = this.populateToData(obj);
                if (this.isNew(obj)) {
                    let deviceRef: any = {};
                    //when you set the id before saving
                    if (obj.is_new == true) {
                        deviceRef = this.getDb()
                            .collection(this.databaseName())
                            .doc(obj.id);
                    }
                    else {
                        deviceRef = this.getDb()
                            .collection(this.databaseName())
                            .doc();
                    }

                    await deviceRef.set(update);
                    delete obj.is_new;
                    obj.id = deviceRef.id;
                    resolve(obj)
                }
                else {
                    let deviceRef = this.getDb()
                        .collection(this.databaseName())
                        .doc(obj.id);
                    // if (!doc.exists) throw `${device.id} not found.`;
                    await deviceRef.update(update)
                    resolve(obj)
                }
            }
            catch (e) {
                reject(e)
            }
        })
    }
    load(id: any): Promise<T> {
        return new Promise<T>(async (resolve, reject) => {
            try {
                var ref = this.getDb()
                    .collection(this.databaseName())
                    .doc(id);

                var doc = await ref.get();
                if (!doc.exists) throw `${id} not found.`;
                let retval = this.populateFromData(doc.data(), ref.id);
                retval.is_new = false;
                resolve(retval);
            } catch (ex) {
                reject(ex);
            }
        });
    }
    archive(id: any): Promise<T> {
        return new Promise<T>(async (resolve, reject) => {
            try {
                let x = await this.load(id);
                x.archived = new Date().toString();
                resolve(await this.save(x))

            }
            catch (e) {
                reject(e)
            }
        });
    }
    constructor(ctx: Context) {
        this.ctx = ctx;
    }
}

export class PodCastStore extends BaseFireStore<model.PodCast> {
    databaseName(): string { return "podcast"; }
    getNewObject(): model.PodCast {

        return new model.PodCast()
    };
    sync(podcast_id: any): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            try {
                let podcastSync = this.ctx.firebase.functions().httpsCallable('podcastSync');
                await podcastSync({ podcast_id: podcast_id });
                resolve()
            }
            catch (e) {
                reject(e);
            }
        })
    }
    validateRssFeed(url: string, ): Promise<model.ValidateRssFeedReponse> {
        return new Promise<model.ValidateRssFeedReponse>(async (resolve, reject) => {
            try {
                let validateRssFeed = this.ctx.firebase.functions().httpsCallable('validateRssFeed');
                let result = await validateRssFeed({ url: url });
                resolve(result.data as model.ValidateRssFeedReponse)
            }
            catch (e) {
                reject(e);
            }
        })
    }
}

export class TrackStore extends BaseFireStore<model.Track> {
    databaseName(): string { return "tracks"; }
    private _grabUrl: any;
    private _processTrackRequest: any;
    listByPodCast(
        podcast_id: any, updateCallback?: UpdateCallback<model.Track>

    ): Promise<Array<model.Track>> {
        return new Promise<Array<model.Track>>(async (resolve, reject) => {
            try {

                ///TODO not sure why this doesn't work
                let results = await this.listCustom([['podcast_id', '==', podcast_id]]);
                
                resolve(results.sort(this.sortByCreateDate))
            }
            catch (er) {
                reject(er);
            }
        })

    }
    sortByPublishDate(a: model.Track, b: model.Track): any {
        let aDate = a.publish_date ? a.publish_date : a.created;
        let bDate = b.publish_date ? b.publish_date : b.created;
        return aDate > bDate ? -1 : 1
    }
    sortByCreateDate(a: model.Track, b: model.Track): any  {
        let aDate = a.created;
        let bDate = b.created;
        return aDate > bDate ? -1 : 1
    }
    waitOnTrack(id: any, timeout: number): Promise<model.Track> {
        return new Promise<model.Track>((resolve, reject) => {

        })
    }
    findCanonicalTrack(canonical_url: string): Promise<model.Track> {
        return new Promise<model.Track>(async (resolve, reject) => {
            try {
                new model.Track().canonical_url
                let col = this.getDb().collection(this.databaseName());
                col = col.where("canonical_url", "==", canonical_url)
                col = col.where("archived", '==', null)
                col = col.where("parent_id", '==', null);
                col = col.where("status", "==", model.TrackStatus.completed)
                let snapshot = await col.get();
                var docs = new Array<model.Track>();


                snapshot.forEach(function (doc: any) {
                    var d = doc.data();
                    d.id = doc.id;
                    docs.push(this.populateFromData(d, doc.id))
                });
                if (docs.length > 0) {
                    resolve(docs[0]);
                }
                resolve(undefined);

            }
            catch (e) {
                reject(e);
            }
        })
    }
    connectToParent(track: model.Track, parentTrack: model.Track): Promise<model.Track> {
        return new Promise<model.Track>(async (resolve, reject) => {
            try {

                track.media = parentTrack.media;
                track.parent_track_id = parentTrack.id;
                track.status = model.TrackStatus.completed;
                let tr = new model.CreateTrackRequest();
                tr.text = "this should not matter";
                tr.track = track;
                let transaction = await this.ctx.Transaction.getPurchaseTransaction(tr, true);
                track.transaction_id = transaction.id;
                await this.ctx.Transaction.commitTransaction(transaction)
                await this.ctx.Track.save(track);
                let podcast = await this.ctx.PodCast.load(track.podcast_id)
                console.log('Podcast', podcast);// Saved.  Save Podcast. Set to dirty')
                podcast.feed_status = model.PodCastFeedStatus.dirty;
                await this.ctx.PodCast.save(podcast);
                return resolve();
            }
            catch (e) {
                reject(e);
            }
        })
    }
    createTrackRequest(url: string): Promise<model.CreateTrackRequest> {
        return new Promise<model.CreateTrackRequest>(async (resolve, reject) => {
            try {
                this._grabUrl = this._grabUrl ? this._grabUrl : this.ctx.firebase.functions().httpsCallable('grabUrlText');
                let result = await this._grabUrl({ url: url });
                resolve(result.data as model.CreateTrackRequest)
            }
            catch (e) {
                reject(e);
            }
        })
    }
    processTrackRequest(request: model.CreateTrackRequest): Promise<model.Track> {
        return new Promise<model.Track>(async (resolve, reject) => {
            try {
                this._processTrackRequest = this._processTrackRequest ? this._processTrackRequest : this.ctx.firebase.functions().httpsCallable('processTrackRequest');
                let result = await this._processTrackRequest({ trackRequest: request });
                resolve(result.data as model.Track)
            }
            catch (e) {
                reject(e);
            }
        })
    }
    getNewObject(): model.Track {

        return new model.Track()
    };
}

export class BackgroundJobStore extends BaseFireStore<model.BackgroundJob> {
    databaseName(): string { return "backgroundJobs"; }

    getNewObject(): model.BackgroundJob {

        return new model.BackgroundJob()
    };
}


export function GetPlans(): Array<model.CustomerPlan> {
    return [
        {
            subscription_cost: 0,
            subscription_cost_currency: "USD",
            subscription_interval: 1,
            subscription_credits: 260,
            credit_threshold: 10000,
            premium_credit_cost: 16,
            normal_credit_cost: 1,
            duplicate_credit_cost: 0,
            premium_per_period: 10*16,
            normal_per_period: 1000,
            duplicate_per_period: 1000,
            max_podcast: 3,
            customize_voice: false,
            podcast_retention_days: 30,
            plan_code: model.PlanCode.trail,
            name: "Free"
        },
        {
            subscription_cost: 0,
            subscription_cost_currency: "USD",
            subscription_interval: 1,
            subscription_credits: 100,
            credit_threshold: 10000,
            premium_credit_cost: 16,
            normal_credit_cost: 1,
            duplicate_credit_cost: 0,
            premium_per_period: 0,
            normal_per_period: 100,
            duplicate_per_period: 100,
            max_podcast: 3,
            customize_voice: false,
            podcast_retention_days: 30,
            plan_code: model.PlanCode.free,
            name: "Free"
        },
        {
            subscription_cost: 5.00,
            subscription_cost_currency: "USD",
            subscription_interval: 1,
            subscription_credits: 260,
            credit_threshold: 10000,
            premium_credit_cost: 16,
            normal_credit_cost: 1,
            duplicate_credit_cost: 0,
            premium_per_period: 10  *16,
            normal_per_period: 1000,
            duplicate_per_period: 1000,
            max_podcast: 10,
            customize_voice: false,
            podcast_retention_days: 365,
            plan_code: model.PlanCode.pro,
            name: "Pro"
        },
        {
            subscription_cost: 16.00,
            subscription_cost_currency: "USD",
            subscription_interval: 1,
            subscription_credits: 900,
            credit_threshold: 10000,
            premium_credit_cost: 50*16,
            normal_credit_cost: 1,
            duplicate_credit_cost: 0,
            premium_per_period: 50  *16,
            normal_per_period: 100,
            duplicate_per_period: 100,
            max_podcast: 99,
            customize_voice: true,
            podcast_retention_days: 365,
            plan_code: model.PlanCode.premium,
            name: "Premium"
        },
        {
            subscription_cost: 0.00,
            subscription_cost_currency: "USD",
            subscription_interval: 1,
            subscription_credits: 900,
            credit_threshold: 10000,
            premium_credit_cost: 50*16,
            normal_credit_cost: 1,
            duplicate_credit_cost: 0,
            premium_per_period: 5000000  *16,
            normal_per_period: 100,
            duplicate_per_period: 100,
            max_podcast: 99,
            customize_voice: true,
            podcast_retention_days: 365,
            plan_code: model.PlanCode.admin,
            name: "Admin"
        },

    ]
}
export class CustomerBalanceStore extends BaseFireStore<model.CustomerBalance> {
    databaseName(): string { return "customerBalance"; }
    getNewObject(): model.CustomerBalance {

        return new model.CustomerBalance()
    };
    getPlan(customerBalance: model.CustomerBalance): Promise<model.CustomerPlan> {
        return new Promise<model.CustomerPlan>((resolve, reject) => {
            let plan_code = customerBalance.plan_code ? customerBalance.plan_code : model.PlanCode.trail
            resolve(GetPlans().find(x => x.plan_code == plan_code))
        })
    }
    
    changePlan(planCode: model.PlanCode): Promise<model.CustomerBalance> {
        return new Promise<model.CustomerBalance>(async (resolve, reject) => {
            try {
                let customerBal = await this.getBalance();
                if (!customerBal.plan_code) {
                    customerBal.plan_code = planCode;
                    customerBal.premiumForPeriod = 0;
                    customerBal.normalForPeriod = 0;
                    customerBal.duplicateForPeriod = 0;
                    let plan = GetPlans().find(x => x.plan_code == customerBal.plan_code);
                    if(!plan)
                        throw "Invalid Plan"
                    let startPeriod = new Date(new Date().setHours(0, 0, 0, 0));
                    customerBal.credits = plan.subscription_credits;
                    let trans = new model.Transaction();
                        trans.credits =  plan.subscription_credits;;
                        trans.transaction_type = model.TransactionType.changePlanAdjustment;
                        trans.description="Start Plan"
                        await this.ctx.Transaction.save(trans);
                    customerBal.startPeriod = startPeriod;
                    customerBal.nextPeriod = moment(new Date(new Date().setHours(0, 0, 0, 0))).add(plan.subscription_interval, 'M').toDate();
                }else if(customerBal.plan_code)
                {
                    let oldPlan = GetPlans().find(x => x.plan_code == customerBal.plan_code);
                    if(!oldPlan)
                        throw "Could not find plan"
                    let newPlan = GetPlans().find(x => x.plan_code == planCode);
                    if(!newPlan)
                        throw "Could not find plan"
                    let changeCredits = newPlan.subscription_credits - oldPlan.subscription_credits;
                    let proratedPercentage =(customerBal.nextPeriod.getTime()-new Date().getTime())/ (customerBal.nextPeriod.getTime()-customerBal.startPeriod.getTime());
                    if(proratedPercentage > 0)
                    {
                        let credits = Math.round(proratedPercentage*changeCredits);
                        let trans = new model.Transaction();
                        trans.credits = credits;
                        trans.transaction_type = model.TransactionType.changePlanAdjustment;
                        trans.description="Change plan "+oldPlan.plan_code+' to plan '+newPlan.plan_code;
                        await this.ctx.Transaction.save(trans);
                    }
                    
                }
                customerBal.plan_code = planCode;
                await this.save(customerBal)
                resolve(customerBal);
            }
            catch (e) {
                reject(e);
            }
        })
    }
    getBalance(): Promise<model.CustomerBalance> {
        return new Promise<model.CustomerBalance>(async (resolve, reject) => {
            try {
                let b = await this.list();

                if (b == null)
                    resolve(undefined)
                if (b.length > 1)
                    throw "error with customer balance"


                return resolve(b[0])
            } catch (e) {
                console.error(e)
                reject(e)
            }
        });
    }
    async getBalanceCredits(): Promise<number> {
        return new Promise<number>(async (resolve, reject) => {
            try {
                let bal = await this.getBalance();
                if (!bal)
                    return resolve(0);
                resolve(bal.credits);
            }
            catch (e) {
                reject(e)
            }
        })
    }
}
export class TransactionStore extends BaseFireStore<model.Transaction> {
    databaseName(): string { return "transaction"; }
    getNewObject(): model.Transaction {
        return new model.Transaction()
    };
    getCreditsNeededForTrackRequest(trackRequest: model.CreateTrackRequest, purchaseType: model.PurchaseType, plan: model.CustomerPlan): number {
        let charCount = trackRequest.text.length;
        let units = Math.ceil(charCount / plan.credit_threshold);
        let credits = 0;
        switch (purchaseType) {
            case (model.PurchaseType.normal): credits = units * plan.normal_credit_cost; break;
            case (model.PurchaseType.premium): credits = units * plan.premium_credit_cost; break;
            case (model.PurchaseType.duplicate): credits = units * plan.duplicate_credit_cost; break;
        }
        return credits;
    }
    commitTransaction(transaction: model.Transaction): Promise<model.Transaction> {
        return new Promise<model.Transaction>(async (resolve, reject) => {
            try {
                resolve(await this.save(transaction));
            }
            catch (e) { reject(e) }
        })
    }
    getPurchaseTransaction(trackRequest: model.CreateTrackRequest, duplicate: boolean): Promise<model.Transaction> {
        return new Promise<model.Transaction>(async (resolve, reject) => {
            try {
                let customerBalance = await this.ctx.CustomerBalance.getBalance();
                let internalDescription = new Array<string>();
                let log = function (str: string) {
                    internalDescription.push(new Date() + ' ' + trackRequest.track.owner_uid + ' ' + str);
                }
                let balance = customerBalance.credits;
                let plan: model.CustomerPlan = await this.ctx.CustomerBalance.getPlan(customerBalance);
                log("Customer Balance " + plan + ' plan ' + plan.plan_code);
                let purchaseType = model.PurchaseType.normal;
                if (duplicate) {
                    purchaseType = model.PurchaseType.duplicate;
                }
                else if (customerBalance.premiumForPeriod < plan.premium_per_period) {

                    purchaseType = model.PurchaseType.premium;
                }
                log("Purchase Type " + purchaseType + ' premiumForPeriod ' + customerBalance.premiumForPeriod);
                let credits = this.getCreditsNeededForTrackRequest(trackRequest, purchaseType, plan);
                if (credits > balance) {
                    console.error( 'Insufficient Credits')
                }
                log("text length " + trackRequest.text + ' credits needed ' + credits)
                let trans = new model.Transaction();
                trans.id = this.ctx.generateNewId();
                trans.credits = -credits;
                trans.amount = 0;
                trans.transaction_type = model.TransactionType.useCreditsOnTrack;
                trans.track_id = trackRequest.track.id;
                trans.purchase_type = purchaseType;
                trans.description = "Purchase for " + trackRequest.track.title;
                trans.log = internalDescription;
                trans.is_new = true;
                resolve(trans)
                // resolve(await this.save(trans))

            }
            catch (e) {
                reject(e);
            }
        })

    }
    /*
    purchaseTrack(trackRequest: model.CreateTrackRequest,duplicate:boolean): Promise<model.Transaction> {
        return new Promise<model.Transaction>(async (resolve, reject) => {
            try {
                let customerBalance = await this.ctx.CustomerBalance.getBalance();
                let internalDescription = [];
                let log = function(str:string)
                {
                    internalDescription.push(new Date()+' '+trackRequest.track.owner_uid+' '+ str);
                }
                let balance = customerBalance.credits;
                let plan  : model.CustomerPlan= await this.ctx.CustomerBalance.getPlan(customerBalance);
                log("Customer Balance "+plan+' plan '+plan.plan_code);
                let purchaseType = model.PurchaseType.normal;
                if(duplicate)
                {
                    purchaseType = model.PurchaseType.duplicate;
                }
                else if(customerBalance.premiumForPeriod < plan.premium_per_period)
                {
    
                    purchaseType = model.PurchaseType.premium;
                }
                log("Purchase Type "+purchaseType+ ' premiumForPeriod '+customerBalance.premiumForPeriod);
                let credits = this.getCreditsNeededForTrackRequest(trackRequest,purchaseType,plan);
                if (credits > balance)
                {
                    throw 'Insufficient Credits'
                }
                log("text length "+trackRequest.text+' credits needed '+credits)
                let trans = new model.Transaction();
                trans.credits = -credits;
                trans.amount = 0;
                trans.transaction_type = model.TransactionType.useCreditsOnTrack;
                trans.track_id = trackRequest.track.id;
                trans.purchase_type = purchaseType;
                trans.description = "Purchase for " + trackRequest.track.title;
                trans.log = internalDescription;
                resolve(await this.save(trans))

            }
            catch (e) {
                reject(e);
            }
        })
    }*/
    addCredit(type: model.TransactionType, amount: number, credits: number, description: string, external_id: any): Promise<model.Transaction> {
        return new Promise<model.Transaction>(async (resolve, reject) => {
            try {
                let trans = new model.Transaction();
                if (type == model.TransactionType.useCreditsOnTrack)
                    throw "Invalid Transaction Type for AddCredit " + type;
                trans.description = description;
                trans.transaction_type = type;
                trans.amount = amount;
                trans.credits = credits;
                trans.external_id = external_id;
                resolve(await this.save(trans))
            }
            catch (e) {
                reject(e);

            }
        })
    }
}
export class CustomerSettingsStore extends BaseFireStore<model.CustomerSettings>{
    databaseName(): string { return "customerSettings"; }
    getNewObject(): model.CustomerSettings {

        return new model.CustomerSettings()
    };
    getSetting(): Promise<model.CustomerSettings> {
        return new Promise<model.CustomerSettings>(async (resolve, reject) => {
            try {
                let b = await this.list();
                if (b == null || b.length == 0) {
                    let cs = new model.CustomerSettings();
                    cs = await this.save(cs);
                    return resolve(cs);
                }
                return resolve(b[0])
            } catch (e) {
                reject(e)
            }
        });
    }

}







// WEBPACK FOOTER //
// ./src/data/dal.ts